import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGridBox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGridBox"><Path d="M8 21H3V16H8V21Z" fill="currentColor"/><Path d="M14.5 21H9.5V16H14.5V21Z" fill="currentColor"/><Path d="M21 21H16V16H21V21Z" fill="currentColor"/><Path d="M8 14.5H3V9.5H8V14.5Z" fill="currentColor"/><Path d="M14.5 14.5H9.5V9.5H14.5V14.5Z" fill="currentColor"/><Path d="M21 14.5H16V9.5H21V14.5Z" fill="currentColor"/><Path d="M8 8H3V3H8V8Z" fill="currentColor"/><Path d="M14.5 8H9.5V3H14.5V8Z" fill="currentColor"/><Path d="M21 8H16V3H21V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGridBox;
